<template>
  <div class="isis-action-list-btn">
    <div class="primary-action-btn">
      <md-button class="md-success" @click.prevent="primaryClickEvt">{{
        $t(primaryTitle)
      }}</md-button>
    </div>
    <div class="action-list-btn">
      <dropdown-button
        title=""
        :actions="actions"
        btnClasses="md-success"
        rightMenu="true"
      />
    </div>
  </div>
</template>

<script>
import DropdownButton from "./DropdownButton";

export default {
  name: "ActionListButton",
  components: { DropdownButton },
  props: [...DropdownButton.props, "primaryBtnSettings"],
  data() {
    return {};
  },
  computed: {
    primaryTitle() {
      return this.primaryBtnSettings
        ? this.primaryBtnSettings.title
        : "common.action";
    },
    primaryClickEvt() {
      return this.primaryBtnSettings
        ? this.primaryBtnSettings.onClick
        : () => {
            console.log("Clicked");
          };
    }
  },
  created() {}
};
</script>

<style lang="scss">
.isis-action-list-btn {
  display: flex;

  .primary-action-btn {
    .md-button {
      border-radius: 100px 0px 0px 100px;
      .md-ripple {
        padding-left: 15px !important;
        padding-right: 15px !important;
      }
    }
  }

  .action-list-btn {
    .isis-dropdown-btn > .dropdown > button.dropdown-toggle {
      min-width: 1px;
      border-radius: 0px 100px 100px 0px !important;

      .md-ripple {
        padding-left: 8px !important;
        padding-right: 10px !important;
      }

      & + .dropdown-menu {
        top: 100%;
      }
    }
  }
}
</style>
